import React from 'react';
import { Outlet } from 'react-router';
import Header from '../components/common/Header/Header';
import TopHeader from '../components/common/Header/TopHeader';

const AppLayout = () => {
  return (
    <section className="flex flex-col w-full h-full min-h-screen">
      <header className=' bg-sidebar-background'>
        <Header />
        <div className="hidden  lg:flex lg:ml-[100px]  bg-sidebar-background">
          <TopHeader />
        </div>
      </header>
      <main className="flex-1 mt-[50px] lg:mt-[2px] lg:ml-[70px] bg-background">
        <Outlet />
      </main>
    </section>
  );
};

export default AppLayout;
